import type { ReactNode } from "react";
import "./ui.css";

interface PageHeaderProps {
	title: string;
	sublabel?: string;
	/**
	 * EQ-2278 item 2. "eyebrow" is the 11px uppercase default every existing call
	 * site renders; "header" makes the sublabel legible as a page header while
	 * staying subordinate to the title. Optional and defaulted, so
	 * StaffAccessPage and Financial are byte-identical.
	 */
	sublabelSize?: "eyebrow" | "header";
	actions?: ReactNode;
}

/* Light page header (.firm-toolbar). Renders NO dark/forest band — a dark
   header on a functional page reads as an error. */
export function PageHeader({
	title,
	sublabel,
	sublabelSize = "eyebrow",
	actions,
}: PageHeaderProps) {
	return (
		<div className="ui-page-header">
			<div className="ui-page-header-titles">
				{sublabel && (
					<p
						className={`ui-page-header-sublabel${
							sublabelSize === "header" ? " is-header" : ""
						}`}
					>
						{sublabel}
					</p>
				)}
				<h1 className="ui-page-header-title">{title}</h1>
			</div>
			{actions && <div className="ui-page-header-actions">{actions}</div>}
		</div>
	);
}
